module.exports = __webpack_public_path__ + "static/media/cha-ri-name.1eb116b6.svg";